import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSafeId } from 'site-modules/shared/hooks/use-safe-id';
import { SCROLL_OFFSET } from 'site-modules/shared/constants/sub-navigation';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';

export function RatingScorecardEmbed({ children, childrenClassName, isEmbed, coreAbTest }) {
  const id = `scorecard-embed-${useSafeId()}`;

  const continueReadingFragment = (
    <em className="d-inline-block mt-1 mb-2 medium text-gray-darker">
      <i className="icon-arrow-down8 small me-0_5" aria-hidden />
      Continue reading Edmunds Expert Rating below
    </em>
  );

  return (
    !!children && (
      <Fragment>
        {isEmbed && (
          <Fragment>
            {coreAbTest ? (
              <Experiment name={coreAbTest} showDefault>
                <Recipe name="ctrl" isDefault>
                  {continueReadingFragment}
                </Recipe>
                <Recipe name="chal">
                  <ScrollLink
                    className="scorecard-embed-scroll-link rounded"
                    to={id}
                    scrollConfig={{ offset: SCROLL_OFFSET }}
                    data-tracking-id="continue_reading"
                  >
                    {continueReadingFragment}
                  </ScrollLink>
                </Recipe>
              </Experiment>
            ) : (
              continueReadingFragment
            )}
          </Fragment>
        )}
        <div className={childrenClassName}>{children}</div>
        {!!coreAbTest && (
          <Experiment name={coreAbTest} showDefault>
            <Recipe name="ctrl" isDefault />
            <Recipe name="chal">
              <ScrollElement id={id} />
            </Recipe>
          </Experiment>
        )}
      </Fragment>
    )
  );
}

RatingScorecardEmbed.propTypes = {
  children: PropTypes.node,
  childrenClassName: PropTypes.string,
  coreAbTest: PropTypes.string,
  isEmbed: PropTypes.bool,
};

RatingScorecardEmbed.defaultProps = {
  children: null,
  childrenClassName: null,
  coreAbTest: null,
  isEmbed: true,
};
